var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
import Toggle from '@web/components/layout/Toggle/Toggle';
import Select from '@web/components/ui/Form/Select';
import { classNames } from '@web/utility';
import { EditDocumentAlertExceptEnum } from '@workalizer/shared';
import { useTranslation } from 'react-i18next';
export var DocAlertsConfigModalSetting = function (_a) {
    var _b;
    var values = _a.values, handleChange = _a.handleChange;
    var t = useTranslation().t;
    var configAlerts = [
        {
            column: 'isShareExternally',
            key: 'shareExternally'
        },
        {
            column: 'isShareViaLink',
            key: 'shareViaLink'
        },
        {
            column: 'isShareAnyone',
            key: 'shareInternally'
        },
        {
            column: 'isRequestAccess',
            key: 'requestAccess'
        },
        {
            column: 'isDownload',
            key: 'download'
        },
        {
            column: 'isPrint',
            key: 'print'
        },
        {
            column: 'isSendToEmail',
            key: 'sendToEmail'
        },
        {
            column: 'isPublish',
            key: 'publish'
        },
        {
            column: 'isCopy',
            key: 'copy'
        },
        {
            column: 'isEdited',
            key: 'edited'
        },
        {
            column: 'isDeleteTrash',
            key: 'deleteTrash'
        },
        {
            column: 'isRenameMove',
            key: 'renameMove'
        }
    ];
    var optionsExpect = Object.values(EditDocumentAlertExceptEnum).map(function (value) { return ({
        id: value,
        name: t("docAlerts.except.".concat(value))
    }); });
    return (_jsxs(_Fragment, { children: [_jsx("div", __assign({ className: "px-4 py-5 sm:p-6" }, { children: _jsx("div", __assign({ className: "mt-5 grid gap-x-8 gap-y-4 grid-cols-4" }, { children: configAlerts.map(function (alert) { return (_jsxs("div", __assign({ className: "flex" }, { children: [_jsx(Toggle, { enabled: values[alert.column], onChange: function () {
                                    handleChange({
                                        target: {
                                            name: alert.column,
                                            value: !values[alert.column]
                                        }
                                    });
                                } }), _jsx("p", __assign({ className: classNames('text-sm pl-2', values[alert.column] ? 'text-gray-800' : 'text-gray-500') }, { children: t("docAlerts.docAlertsConfig.docAlertsConfigTable.triggers.".concat(alert.key)) }))] }), alert.column)); }) })) })), _jsx("div", __assign({ className: "flex justify-center" }, { children: _jsx(Select, { label: t('docAlerts.modal.byAnyoneExcept'), selected: (_b = optionsExpect.find(function (option) { return option.id === values.except; })) !== null && _b !== void 0 ? _b : null, options: optionsExpect, onChange: function (option) {
                        handleChange({
                            target: {
                                name: 'except',
                                value: option.id
                            }
                        });
                    }, placeholder: t('docAlerts.modal.byAnyoneExceptPlaceholder') }) }))] }));
};
export default DocAlertsConfigModalSetting;
